<template>
  <div class="dko-table">
    <v-card-title class="pa-0">
      <div class="mb-3">
        {{ header }}
      </div>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="requests"
      hide-default-footer
      :loading="isLoading"
      :items-per-page="100"
      class="custom-table mt-6"
    >
      <template #[`item.name`]="{ item }">
        <router-link
          class="darken--text underlined-hover"
          :to="{ name: 'dko-cooperation-single', params: { id: item.id } }"
        >
          {{ item.name }}
        </router-link>
      </template>

      <template #[`item.department`]="{ item }">
        <span class="dko-table__ellipsis">{{ item.department }}</span>
      </template>

      <template #[`item.purpose`]="{ item }">
        <span class="dko-table__ellipsis">{{ item.purpose }}</span>
      </template>

      <template #[`item.updatedAt`]="{ item }">
        {{ item.updatedAt | dateWithTime }}
      </template>

      <template #no-data>
        <AppEmptyList
          class="py-16"
          :header="emptyHeader"
          :text="emptyText"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';

export default {
  components: { AppEmptyList },
  props: {
    requests: {
      type: Array,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    emptyHeader: {
      type: String,
      default: 'Brak wniosków.',
    },
    emptyText: {
      type: String,
      default: 'Brak wniosków w tym widoku.',
    },
  },
  computed: {
    ...mapState(['isLoading']),
    headers() {
      return [
        { text: 'Nazwa materiału', value: 'name', sortable: false },
        { text: 'Numer wniosku', value: 'reference', sortable: false },
        { text: 'Departament', value: 'department', sortable: false },
        { text: 'Cel przekazania materiału', value: 'purpose', sortable: false },
        { text: 'Ostatnia zmiana', value: 'updatedAt', sortable: false },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.dko-table {
  min-height: 360px;

  &__ellipsis {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
